import {
    PopoverContent,
    PopoverRoot,
    PopoverTrigger,
} from '@/src/common/components/elements/Buttons/Popover'
import { faInfo } from '@fortawesome/free-solid-svg-icons/faInfo'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Link from 'next/link'
import {
    LabelText,
    TextContainer,
    ValueText,
} from '@/src/modules/OrderStatus/StyledComponents'
import {
    filterDataByLocation,
    getDeliveryStatusUpdate,
} from '@/src/common/components/elements/DeliveryTracker/DeliveryTracker'
import { FAQ_PAGE } from '../../pg-plus/constants'

const LineItemDetailsPhysical = ({
    tracking,
    address = '',
    imbData,
}: {
    tracking: any[]
    address: string
    imbData: any[] | null
}) => {
    return (
        <>
            <TextContainer>
                <LabelText>Addressed to:</LabelText>
                &nbsp;
                <ValueText data-testid={'delivery-address'}>
                    {address}
                    &nbsp;
                    <PopoverRoot>
                        <PopoverTrigger variant={'default'}>
                            <FontAwesomeIcon icon={faInfo} />
                        </PopoverTrigger>
                        <PopoverContent>
                            For security purposes&#44; your recipient&#39;s
                            shipping address is intentionally obscured here. For
                            more information, see our list of{' '}
                            <Link href={FAQ_PAGE} aria-label={'faq-button'}>
                                frequently asked questions
                            </Link>
                            .
                        </PopoverContent>
                    </PopoverRoot>
                </ValueText>
            </TextContainer>
            {!!imbData && (
                <TextContainer>
                    <LabelText data-testid={'delivery-updates'}>
                        Delivery Updates: &nbsp;
                    </LabelText>
                    <ul
                        style={{
                            padding: '0px 0px 0px 20px',
                            margin: '5px 0px 0px',
                        }}
                    >
                        {filterDataByLocation(imbData).map((data, i) => {
                            return (
                                <li
                                    key={'delivery-update-' + i}
                                    data-testid={'delivery-update-' + i}
                                >
                                    {getDeliveryStatusUpdate(data)}
                                </li>
                            )
                        })}
                    </ul>
                </TextContainer>
            )}
            {!!tracking?.length && (
                <TextContainer>
                    <LabelText>Tracking #:</LabelText>
                    &nbsp;
                    <ValueText data-testid={'tracking-info'}>{`${
                        tracking[tracking.length - 1]
                    }`}</ValueText>
                </TextContainer>
            )}
        </>
    )
}
export default LineItemDetailsPhysical
